import { useEffect, useState } from 'react'
import { viewportTier } from './oled'

export function useViewportTier(): 'hd' | '4k' {
  const [tier, setTier] = useState<'hd' | '4k'>(() => viewportTier(window.innerWidth))

  useEffect(() => {
    const mql = window.matchMedia('(min-width: 2560px)')
    const update = () => setTier(mql.matches ? '4k' : 'hd')
    mql.addEventListener('change', update)
    return () => mql.removeEventListener('change', update)
  }, [])

  return tier
}
